import { combineReducers } from 'redux';

import { generateAsyncReducer } from '../../../utils';
import { IContactDetails, IContactState } from '../models';
import { EContactActions } from './enums';

export const ContactReducers = combineReducers<IContactState>({
    configuration: generateAsyncReducer<IContactDetails>(EContactActions.GET_CONFIG),
    sendMessage: generateAsyncReducer<void>(EContactActions.SEND_MESSAGE),
});
